import { createApp } from 'vue';
import Redeem from "./Redeem.vue";

const element = document.getElementById('redeem-app');

if (element) {
  const app = createApp(Redeem);
  app.mount(element);
}
